// Per-tab storage survives Save/reload after the original Storyblok URL stamp
// expires. The server still verifies the token's slug binding and 12h expiry.
export const recoverLivePreviewToken = (fullSlug: string, token: string | null): string | null => {
  try {
    const key = `sb-live-token:${fullSlug}`
    if (token) {
      window.sessionStorage.setItem(key, token)
      return token
    }
    const stored = window.sessionStorage.getItem(key)
    const expiresAt = Number(stored?.split('.')[0])
    return stored && Number.isFinite(expiresAt) && expiresAt > Date.now() ? stored : null
  } catch {
    // Some third-party iframe privacy settings block sessionStorage.
    return token
  }
}
